import React, { useState, useRef } from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Organicé toda mi carrera en un fin de semana. Tengo cada parcial pensado y cada planificación lista para entregar. Nunca más el domingo de pánico antes de las prácticas docentes.',
  name: 'Sofía M.',
  role: 'Estudiante del Profesorado de EF',
  location: '📍 Buenos Aires'
}, {
  quote: 'Las guías de Anatomía y Fisiología cambiaron todo. Aprobé dos materias que había llevado a diciembre el año anterior. Avancé más en 2 meses con este kit que en todo el año anterior sola.',
  name: 'Lucas R.',
  role: 'Estudiante de 2do año del Profesorado de EF',
  location: '📍 Rosario'
}, {
  quote: 'Armo mi plan de clase en 10 minutos con las plantillas. Antes me llevaba horas buscar formatos en Google y nunca encontraba algo útil para EF.',
  name: 'Valentina F.',
  role: 'Estudiante en Prácticas Docentes',
  location: '📍 Córdoba'
}];
export function QuickTestimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const {
      scrollLeft,
      scrollWidth
    } = scrollRef.current;
    const itemWidth = scrollWidth / testimonials.length;
    setActiveIndex(Math.round(scrollLeft / itemWidth));
  };
  return <section className="py-6 md:py-10 bg-white border-b border-gray-100 overflow-hidden" data-id="element-333">
      <div className="max-w-6xl mx-auto px-4" data-id="element-334">
        {/* Mobile Carousel */}
        <div className="md:hidden" data-id="element-335">
          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar gap-4 pb-4 -mx-4 px-4" data-id="element-336">
            {testimonials.map((t, i) => <div key={i} className="min-w-[85%] snap-center bg-gray-50 rounded-2xl p-4 border border-gray-100 shadow-sm" data-id="element-337">
                <div className="flex gap-1 mb-3" data-id="element-338">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" data-id="element-339" />)}
                </div>
                <p className="text-gray-700 italic mb-4 text-sm leading-relaxed" data-id="element-340">
                  "{t.quote}"
                </p>
                <div data-id="element-341">
                  <p className="font-bold text-brand-900 text-sm" data-id="element-342">{t.name}</p>
                  <p className="text-[11px] text-gray-500 mt-0.5" data-id="element-343">{t.role}</p>
                  <p className="text-[11px] font-medium text-brand-600 mt-1" data-id="element-344">
                    {t.location}
                  </p>
                </div>
              </div>)}
          </div>
          {/* Dots */}
          <div className="flex justify-center gap-1.5 mt-2" data-id="element-345">
            {testimonials.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${i === activeIndex ? 'w-4 bg-brand-600' : 'w-1.5 bg-gray-300'}`} data-id="element-346" />)}
          </div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-3 gap-6" data-id="element-347">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-348">
              <div className="flex gap-1 mb-4" data-id="element-349">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-350" />)}
              </div>
              <p className="text-gray-700 italic mb-6 text-sm leading-relaxed" data-id="element-351">
                "{t.quote}"
              </p>
              <div data-id="element-352">
                <p className="font-bold text-brand-900 text-sm" data-id="element-353">{t.name}</p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-354">{t.role}</p>
                <p className="text-xs font-medium text-brand-600 mt-1" data-id="element-355">
                  {t.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}